module.exports = __webpack_public_path__ + "img/thumbnail_SlothBear_f_albino.85889135.png";